import {createSelector} from 'reselect';
import {RootState} from '../rootReducer';

export const loadingStatus = createSelector(
  [state => state.auth.isLoading],
  isLoading => isLoading,
);

export const getOrgID = createSelector(
  [(state: RootState) => state.user.authData?.org_id],
  org_id => org_id,
);

export const getUserID = createSelector(
  [(state: RootState) => state.user.authData?.id],
  id => id,
);

export const orgRole = createSelector(
  [(state: RootState) => state.user.authData?.org_role],
  org_role => org_role,
);

export const otpTimer = createSelector(
  [(state: RootState) => state.user.otpTimer],
  timer => timer,
);

export const otpAttemps = createSelector(
  [(state: RootState) => state.user.otpAttempts],
  attempts => attempts,
);

export const resetPasswordCheck = createSelector(
  [(state: RootState) => state.user.canResetPassword],
  canResetPassword => canResetPassword,
);

export const recoverEmail = createSelector(
  [(state: RootState) => state.user.emailToRecover],
  emailToRecover => emailToRecover,
);

export const getAuthError = (state: RootState) => state.user.errorSignIn;
export const getAuthSuccess = (state: RootState) => state.user.successSignin;
export const getAuthData = (state: RootState) => state.user.authData;
export const authStatus = (state: RootState) => state.user.isAuthenticated;
export const checkPasswordUpdated = (state: RootState) =>
  state.user.authData?.is_password_updated;
